import React, { Fragment, useEffect, useRef,useState,useContext } from "react";
import Landing from "./screens/Landing";
import Description from "./screens/Description";
import Cocktails from "./screens/Cocktails";
import { GlobalStyles } from "./modules/globalStyles";
import { __RouterContext,Switch,Route } from "react-router-dom";
import { useTransition, animated } from "react-spring";
import mainLogo from "./assets/ademars/APxM_logo_Stacked-02.png";
import ReactGa from "react-ga";
import {
  LoadScreen,
  LoadContainer,
} from "./screens/Landing/landingStyles";
import CommicBook from './components/CommicBook'
import comicBack from  './assets/ademars/comic-back.png'

import { TimelineMax, Power3 } from "gsap";
import 'swiper/swiper-bundle.css';
import "./App.css";
import $ from "jquery";
import {TweenMax, Power4} from 'gsap'



import Experts from "./screens/Experts";
import EndScreen from "./screens/EndScreen";
import LastWrapUp from "./screens/LastWrapUp";
import ScrollIndicator from "./components/ScrollIndicator";
import ScrollIndicatorLanding from './components/ScrollIndicatorLanding'
import WrapUpNov12 from "./screens/WrapUpNov12";
import WrapUpNov19 from "./screens/WrapUpNov19";
import InstructionOverlay from "./components/InstructionOverlay";
import Turn from "./components/Turn";
import {ComicContainer} from './modules/globalStyles'
import CoverPage from "./screens/CoverPage";
import previewImage from './assets/ademars/Preview-Link-Image.png'

function App() {

  // ref
  let swiperrr = useRef(null);
  let loaderBottom = useRef(null);
  let screen = useRef(null)

  // states
  // const [allowSwipe ,setAllowSwipe] = useState(true)
  const [legal ,setLegal] = useState(false)
  const [showScrollIndicator, setShowScrollIndicator] = useState(false)
  const [showScrollIndicatorLanding, setShowScrollIndicatorLanding] = useState(false)
  const [showWrapUp, setShowWrapUp] = useState(false)
  const [showWrapUpNov12, setShowWrapUpNov12] = useState(false)
  const [showWrapUpNov19, setShowWrapUpNov19] = useState(false)
  const [swiperActiveIndex, setSwiperActiveIndex] = useState(1)
  const [videoActive, setVideoActive] = useState(false)
  const [showInsrtuctionOverlay, setShowInsrtuctionOverlay] = useState(false)
  const [scrollRefreshWithoutDelay, setScrollRefreshWithoutDelay] = useState(false)
  const [playVideoOne, setPlayVideoOne] = useState(false)
  const [playVideoTwo, setPlayVideoTwo] = useState(false)
  const [playVideoThree, setPlayVideoThree] = useState(false)
  const [canvasOneHeight, setCanvasOneHeight] = useState(0)
  const [canvasTwoHeight, setCanvasTwoHeight] = useState(0)
  const [showInitialPeel, setShowInitialPeel] = useState(false)

  useEffect(()=>{
    window.addEventListener('resize', handleResize)
    return() => window.removeEventListener('resize', handleResize)
  })

  useEffect(()=>{
      $('img').attr('draggable', false);
      setTimeout(()=>{
        setCanvasOneHeight(document.getElementById('canvas-1').offsetHeight)
        setCanvasTwoHeight(document.getElementById('canvas-2').offsetHeight)
      },500)
  },[])
  useEffect(()=>{
    window.addEventListener('scroll', scrollListener,true)
    return () => window.removeEventListener('scroll', scrollListener,true)
  })

  var checkScrollSpeed = (function(settings){
    settings = settings || {};

    var lastPos, newPos, timer, delta, 
        delay = settings.delay || 50; // in "ms" (higher means lower fidelity )

    function clear() {
      lastPos = null;
      delta = 0;
    }

    clear();

    return function(){
      newPos = window.scrollY;
      if ( lastPos != null ){ // && newPos < maxScroll 
        delta = newPos -  lastPos;
      }
      lastPos = newPos;
      clearTimeout(timer);
      timer = setTimeout(clear, delay);
      return delta;
    };
})();

    const scrollListener = (e) => {

      let scrollSpeed  = checkScrollSpeed()

      console.warn(scrollSpeed)

      if(swiperActiveIndex === 2){

        // video distance from top
        const videoOneFromtop = document.getElementById("video-one").getBoundingClientRect().top
        const videoFromtop = document.getElementById("video-two").getBoundingClientRect().top
        const fireFromtop = document.getElementById("video-three").getBoundingClientRect().top


        if( videoOneFromtop > 100 && videoOneFromtop < (window.innerHeight/100) * 55){
          setPlayVideoOne(true)
        }else{
          setPlayVideoOne(false)
        }

        // video one player login
        if( videoFromtop > 100 && videoFromtop < (window.innerHeight/100) * 55){
          setPlayVideoTwo(true)
        }else{
          setPlayVideoTwo(false)
        }

        // video two player login
        if( fireFromtop > 100 && fireFromtop < (window.innerHeight/100) * 55){
          setPlayVideoThree(true)
        }else{
          setPlayVideoThree(false)
        }
      }
    }

  const handleResize = () =>{
    if(swiperActiveIndex === 2){
      setCanvasOneHeight(document.getElementById('canvas-1').offsetHeight)
      setCanvasTwoHeight(document.getElementById('canvas-2').offsetHeight)
    }
  }

  const screens = [
    { path: "/description", name: "Description", component: <CoverPage legal={legal} showScrollIndicator={showScrollIndicator}/> },
    {path:'./back', name: 'back', component: <img src={comicBack} style={{width:"100%", height:'100%'}} />},
    { path: "/", name: "Landing", 
    component: <Landing
    swiperActiveIndex={swiperActiveIndex} 
    setShowInsrtuctionOverlay={(val)=> setShowInsrtuctionOverlay(val)}
    playVideoOne={playVideoOne}
    playVideoTwo={playVideoTwo}
    playVideoThree={playVideoThree}
    setPlayVideoOne={setPlayVideoOne}
    setPlayVideoTwo={setPlayVideoTwo}
    setPlayVideoThree={setPlayVideoThree}
    canvasOneHeight={canvasOneHeight}
    canvasTwoHeight={canvasTwoHeight}
    /> },
    {path:'./back', name: 'back', component: <img src={comicBack} style={{width:"100%", height:'100%'}} />},
    // { path: "/description", name: "Description", component: <Description legal={legal} showScrollIndicator={showScrollIndicator}/> },
    // {path:'./bac2', name: 'bac2', component: <img src={comicBack} style={{width:"100%", height:'100%'}} />},
    // { path: "/experts", name: "Experts", component: <Experts /> },
    // {path:'./bac2', name: 'bac2', component: <img src={comicBack} style={{width:"100%", height:'100%'}} />},
    { path: "/thankyou", name: "EndScreen", component: <EndScreen showWrapUp={showWrapUp} setShowWrapUp={val => setShowWrapUp(val)} setShowWrapUpNov12={val => setShowWrapUpNov12(val)} setShowWrapUpNov19 = {val => setShowWrapUpNov19(val)} /> },
  ];

  const options2 = {
    width: "200%",
    height: window.innerHeight,
    autoCenter: false,
    display: "double",
    acceleration: true,
    gradients: !$.isTouch,
    turnCorners: 'bl,br,r',
    duration: 1000,
    when: {
      turned: function(e) {
        let page  = $(this).turn("view")[0]
        if(page === 2 ){
          setShowScrollIndicatorLanding(true)
        }else{
          setShowScrollIndicatorLanding(false)
        }
        {
          if(page === 2){
            document.getElementById("scroll-indicator-wrapper").style.display = "none"
            document.getElementById("scroll-indicator-landing-wrapper").style.display = "initial"
            // window.history.pushState({}, "", "/")
          }
          if(page === 4){
            document.getElementById("scroll-indicator-wrapper").style.display = "none"
            document.getElementById("scroll-indicator-landing-wrapper").style.display = "none"
            // window.history.pushState({}, "", "/behind-the-scene")
          }
          if(page === 6){
            document.getElementById("scroll-indicator-wrapper").style.display = "none"
            document.getElementById("scroll-indicator-landing-wrapper").style.display = "initial"
            // window.history.pushState({}, "", "/subscribe")
          }
          if(page === 8){
            document.getElementById("scroll-indicator-wrapper").style.display = "none"
            document.getElementById("scroll-indicator-landing-wrapper").style.display = "none"
            // window.history.pushState({}, "", "/thankyou")
          }
        }
        setSwiperActiveIndex(page)
        setPlayVideoOne(false)
        setPlayVideoTwo(false)
        setPlayVideoThree(false)
        setVideoActive(false)
        // console.warn('page', $(this).turn("view")[1])
        if(page === 2){
          document.getElementById('next-arrow').style.opacity = 1
          document.getElementById('prev-arrow').style.opacity = 0.5
        }else if(page === 4){
          document.getElementById('next-arrow').style.opacity = 0.5
          document.getElementById('prev-arrow').style.opacity = 1
        }else{
          document.getElementById('next-arrow').style.opacity = 1
          document.getElementById('prev-arrow').style.opacity = 1
        }
      },
      turning: function(e){
        setShowScrollIndicator(false)
        setShowScrollIndicatorLanding(false)
      },
      start: function(e, pageObj, corner){
        // if(pageObj.page === 1  && (corner === 'br' || corner === 'tr')){
        //   e.preventDefault()
        // }
        // alert("wp")
        // e.preventDefault()
        // if(corner === 'br' || corner === 'tr'){
        //   e.preventDefault()
        // }
      },
    }
  };
  
  const pages = [
    "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/01.jpg",
    "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/02.jpg",
    "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/03.jpg",
    "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/04.jpg",
    "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/05.jpg",
    "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/06.jpg"
  ];

  
  useEffect(()=>{
    window.addEventListener("touchstart", touchListener)

    return () => window.removeEventListener("touchstart", touchListener) 
  },)
  useEffect(()=>{
    window.addEventListener("click", touchListener)

    return () => window.removeEventListener("click", touchListener) 
  },)

  const touchListener = (e) => {
    if(!videoActive && swiperActiveIndex === 2){
      setPlayVideoOne(true)
      setPlayVideoTwo(true)
      setPlayVideoThree(true)
      // document.getElementById("water-video").play()
      // document.getElementById("water-video").pause()
      setVideoActive(true)
      // alert("working")
    }
  }

  useEffect(()=>{
    if(document.cookie.length){
      if(document.cookie.includes("legal=true") ){
        setLegal(true)
      }
    }
    
  },[])

  useEffect(() => {
    ReactGa.initialize("UA-164685403-9");
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, []);

  // useEffect(() => {
  //     let screenHeight = window.innerHeight;
  //     let tl = new TimelineMax();
  //     tl.to(loaderBottom, {
  //       duration: 1.2,
  //       top: `${-screenHeight}px`,
  //       ease: Power3.easeInOut,
  //     });
  //     tl.to(loaderBottom, {
  //       duration: 1,
  //       height: "0%",
  //       ease: Power3.easeInOut,
  //       delay: 0.3,
  //     });
  // }, []);


  useEffect(()=>{
    window.addEventListener("scroll", listener)
    return ()=> window.removeEventListener("scroll",listener)
  })
  const listener = (e) => {
    setShowScrollIndicator(false)
  }


  return (
    <Fragment>
      <div id="scroll-indicator-wrapper">
      {showScrollIndicator && <ScrollIndicator />}
      </div>
      <div id="scroll-indicator-landing-wrapper">
        {showScrollIndicatorLanding && <ScrollIndicatorLanding scrollRefreshWithoutDelay={scrollRefreshWithoutDelay} />}
      </div>
      {showInsrtuctionOverlay && <InstructionOverlay setShowInsrtuctionOverlay={(val) => {
        setShowInsrtuctionOverlay(val)
        setShowScrollIndicatorLanding(true)
        setShowInitialPeel(true)
        }} />}
      {showWrapUp && <LastWrapUp setShowWrapUp={val => setShowWrapUp(val)} />} 
      {showWrapUpNov12 && <WrapUpNov12 setShowWrapUpNov12={val => setShowWrapUpNov12(val)} />}
      {showWrapUpNov19 && <WrapUpNov19 setShowWrapUpNov19={val => setShowWrapUpNov19(val)} />}
      <div className="hide">
        <img src={previewImage} />
      </div>
      <GlobalStyles />
      {/* <LoadContainer>
        <LoadScreen
          ref={(ref) => {
            loaderBottom = ref;
          }}
        >
          <div>
            <img src={mainLogo} />
          </div>
        </LoadScreen>
        
      </LoadContainer> */}
      <ComicContainer>
        <Turn options={options2} className="magazine"
        setShowInsrtuctionOverlay={(val)=> setShowInsrtuctionOverlay(val)}
        scrollListener={scrollListener}
        showInitialPeel={showInitialPeel}
        setShowInitialPeel={val => setShowInitialPeel(val)}
        >
            {screens.map((screen)=>(
              <div  key={screen.name} className="page">
                  {screen.component}
                </div>
                ))}
        </Turn>
        {/* <div style={{
          width:100,
          height:100,
          position:'absolute',
          top:0,
          right:0
        }}></div>
        <div style={{
          width:100,
          height:100,
          position:'absolute',
          bottom:0,
          right:0
        }}></div> */}
      </ComicContainer>
    </Fragment>
  );
}

export default App;

